var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('li',{on:{"click":_vm.showContent}},[_c('a',{staticClass:"dropdown-item fs-16 d-inline-flex align-items-center",attrs:{"role":"button"}},[_c('i',{staticClass:"fi fi-rr-guide me-2 text-gray-700"}),_vm._v("\n        "+_vm._s(_vm.trans('general.page.learn_about_this_page'))+"\n    ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }